module.exports = __webpack_public_path__ + "img/header-diamondJewelryExclusive@2x.e09cced.webp";